import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IOrganizerState }      from 'Redux/Slices/Organizer/OrganizerSlice';
import { Organizer }            from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const createOrganizerRequest = (state: Draft<IOrganizerState>, { type }: PayloadAction<{ id: string, formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const createOrganizerSuccess = (state: Draft<IOrganizerState>, { type, payload }: PayloadAction<{
  organizer: Organizer
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.organizer.id;
  state.entries = { ...state.entries, [payload.organizer.id]: payload.organizer };
};

export const createOrganizerFailure = (state: Draft<IOrganizerState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
